export default __webpack_public_path__ + "static/wedding_insurance_3-fcd060ece8305e95f48c716c1ff5c63e.webp";